export default __webpack_public_path__ + "static/media/people7small.7cc824d9.jpg";